<div class="card-body">
    <canvas height="100px" id="basic_bar_chart"></canvas>
</div>